import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import type { ChangeInvestigationTypeCommand } from './change-investigation-type.command';
import type { ChangeInvestigationTypeResult } from './change-investigation-type.result';

@Injectable({ providedIn: 'root' })
export class ChangeInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);
  private readonly _toast = inject(ToastProvider);

  public execute(command: ChangeInvestigationTypeCommand): Observable<ChangeInvestigationTypeResult> {
    this._state.setChangingInvestigationType(true);

    return this._repository
      .changeInvestigationType(command.investigationId, command.investigationTypeId)
      .pipe(
        tap(() => {
          const body = command.investigationTypeName
            ? `This case is now classified as “${command.investigationTypeName}”. Complete the Employee Relations intake fields below.`
            : 'This case has been reclassified. Complete the Employee Relations intake fields below.';
          this._toast.success('ER case type applied', body);
        }),
        map(() => ({ success: true, investigationId: command.investigationId })),
        catchError((error) => {
          this._toast.error(
            'Failed to update investigation type',
            'Please try again or contact support.',
          );
          return throwError(() => error);
        }),
        // finalize covers complete, error AND unsubscribe (e.g. the modal closing before the
        // request resolves), so changingInvestigationType never sticks.
        finalize(() => {
          this._state.setChangingInvestigationType(false);
        }),
      );
  }
}
